import EventViewEditPointsForm from './EventViewEditPointsForm';

export default EventViewEditPointsForm;
